import { TAElementGroup } from './taelement'

export interface BidEvalWebResult {
  checkpointeval: CheckPointEvalGroupWebResult;
  scoretypestring?: string;          // backing field for scoretype enum
  scoringelements: TAElementGroup[];

  // computed getter (often serialized)
  scoreint?: number;

  answersha?: string;
  inwintheme?: boolean;              // default true on server
}

interface CheckPointEvalGroupWebResult {
  groups?: unknown[];   // tighten when you share the C# definition
  scoreint?: number;    // implied by bideval.scoreint getter
}

// Sentinel "no scoring yet" instance. Use to clear a question's bideval
// via updateQuestion without casts - `?.scoreint` reads still come back
// undefined so existing `hasScore` / "score done" checks short-circuit.
export const EMPTY_BIDEVAL: BidEvalWebResult = {
  checkpointeval: {},
  scoringelements: [],
}

